import React from "react";

export default function BlogCategoryList({
  categories = [],
  activeCategory = "all",
  onSelect,
}) {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onSelect("all")}
        className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
          activeCategory === "all"
            ? "bg-orange-600 text-white"
            : "bg-gray-100 text-gray-700 hover:bg-gray-200"
        }`}
      >
        Semua
      </button>

      {categories.map((category) => (
        <button
          key={category.slug}
          type="button"
          onClick={() => onSelect(category.slug)}
          className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
            activeCategory === category.slug
              ? "bg-orange-600 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
}
